'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var components_text_Text = require('../text/Text.js');
var utilities_combineClasses = require('../../_chunks/combineClasses-5P8GTQkg.js');
var theme_index = require('../../_chunks/index-CIVOGJRG.js');
require('../../_chunks/fonts-CZ0t0x6L.js');
require('../../_chunks/designTokens-CKP-YoT2.js');

require("../../_assets/Separator-CPUD3q8K.css");var styles = {"contents":"Separator__yvWXYBXEMd__contents","horizontal":"Separator__yvWXYBXEMd__horizontal","margin":"Separator__yvWXYBXEMd__margin","separator":"Separator__yvWXYBXEMd__separator","separatorLine":"Separator__yvWXYBXEMd__separatorLine","vertical":"Separator__yvWXYBXEMd__vertical"};

const Separator = react.forwardRef(({ direction = 'horizontal', testId, children, margin, className, theme: _theme, style, ...props }, ref) => (jsxRuntime.jsxs("div", { "data-theme": _theme, "data-testid": testId, "data-direction": direction, className: utilities_combineClasses.combineClasses(styles.separator, margin && styles.margin, direction === 'vertical' && styles.vertical, direction === 'horizontal' && styles.horizontal, className), style: {
        '--separator--margin': margin ? theme_index.theme.spacing[margin] : undefined,
        ...style,
    }, ...props, ref: ref, children: [jsxRuntime.jsx("div", { className: styles.separatorLine }), children && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx(components_text_Text.Text, { className: styles.contents, color: "gray-700", children: children }), jsxRuntime.jsx("div", { className: styles.separatorLine })] }))] })));
Separator.displayName = 'Separator';

exports.Separator = Separator;
//# sourceMappingURL=Separator.js.map
